import * as basicLightbox from "basiclightbox";

window.navigation = () => {
    return {
        modal: null,
        _scrollPosition: 0,
        isOpen: false,

        init() {
            this.modal = basicLightbox.create(this.$el.querySelector(".mobile-navigation-menu"), {
                className: "basicLightbox--navigation",
                onShow: () => {
                    this.isOpen = true;
                    this._scrollPosition = window.pageYOffset;
                    document.body.classList.add("basicLightbox--enabled");
                    document.body.style.top = `-${this._scrollPosition}px`;

                    document.addEventListener("keydown", (event) => {
                        if (event.key === "Escape") {
                            this.close();
                        }
                    });
                },
                onClose: () => {
                    this.isOpen = false;
                    document.body.classList.remove("basicLightbox--enabled");
                    document.body.style.top = null;
                    window.scrollTo({
                        top: this._scrollPosition,
                        behavior: "instant",
                    });
                },
            });

            const navigationBreakpoint = window.matchMedia("(min-width: 1024px)");
            navigationBreakpoint.addListener(this.closeNavigationOnBreakpointChange.bind(this));
        },

        toggle() {
            this.isOpen ? this.close() : this.open();
        },

        open() {
            this.modal.show();
        },

        close() {
            this.modal.close();
        },

        closeNavigationOnBreakpointChange(x) {
            if (x.matches && this.isOpen) {
                this.close();
            }
        },
    };
};
